import React from 'react';
import { ProductsContent, QuoteContent, StepContent, TextContent } from './SuccessStoryDto';
import Icon from '@lib/components/Icon';

export interface StepProps {
    content: StepContent;
    next?: () => void;
    nextHeadline?: string;
}

export interface ContentProps {
    next?: () => void;
    nextHeadline?: string;
}

export default class Step extends React.Component<StepProps> {
    render() {
        const { content, next, nextHeadline } = this.props;
        const contentProps: ContentProps = { next, nextHeadline };

        switch (content.type) {
            default:
                return null;
            case 'text':
                return <TextContentComponent {...contentProps} content={content} />;
            case 'products':
                return <ProductsContentComponent {...contentProps} content={content} />;
            case 'quote':
                return <QuoteContentComponent {...contentProps} content={content} />;
        }
    }
}

function TextContentComponent({ content, next, nextHeadline }: ContentProps & { content: TextContent }) {
    return (
        <div className="step--text-content">
            <h3 className="h4 is-desktop-only">{content.headline}</h3>
            <p className="body-copy">{content.body}</p>
            {nextHeadline && (
                <div className="buttons is-right mt-0.5 is-desktop-only">
                    <button type="button" className="button button--narrow-text" onClick={next}>
                        <span>{nextHeadline}</span>
                        <Icon icon="arrow-right" />
                    </button>
                </div>
            )}
        </div>
    );
}

type ProductContentComponentProps = ContentProps & { content: ProductsContent };
function ProductsContentComponent({ content, next, nextHeadline }: ProductContentComponentProps) {
    return (
        <div className="step--products-content">
            <h3 className="h4 is-desktop-only mb-1.5">{content.headline}</h3>
            {content.products.map((product, index) => (
                <a key={index} href={product.href} className="product-teaser-thumbnail mb-0.5">
                    <div className="product-teaser-thumbnail__image">
                        <img src={product.image.src} alt={product.image.alt} />
                    </div>
                    <div className="product-teaser-thumbnail__text">{product.name}</div>
                </a>
            ))}
            {nextHeadline && (
                <div className="buttons is-right mt-0.5 is-desktop-only">
                    <button type="button" className="button button--primary" onClick={next}>
                        <span>{nextHeadline}</span>
                        <Icon icon="arrow-right" />
                    </button>
                </div>
            )}
        </div>
    );
}

type QuoteContentComponentProps = ContentProps & { content: QuoteContent };
export function QuoteContentComponent({ content, next, nextHeadline }: QuoteContentComponentProps) {
    return (
        <div className="step--quote-content">
            <div className="mb-1">
                <Icon className="is-size-48px is-size-56px@desktop" icon="quote" />
            </div>
            <p className="step--quote-content__quote mb-1.5">{content.body}</p>
            <div className="step--quote-content__author">
                <img src={content.image.src} alt={content.image.alt} />
                <div className="underline is-currentColor mt-0">{content.title}</div>
            </div>
            {nextHeadline && (
                <div className="buttons is-right mt-0.5 is-desktop-only">
                    <button type="button" className="button button--narrow-text" onClick={next}>
                        <span>{nextHeadline}</span>
                        <Icon icon="arrow-right" />
                    </button>
                </div>
            )}
        </div>
    );
}
